(function () {
  var storageKey = 'rit_recently_viewed_v1';

  function readViewed() {
    try {
      var value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function recordCurrentProduct() {
    var data = document.getElementById('rit-recently-viewed-current-product');
    if (!data) return;
    try {
      var item = JSON.parse(data.textContent || '{}');
      if (!item.handle || !item.url) return;
      var viewed = readViewed().filter(function (entry) {
        return entry && entry.handle !== item.handle;
      });
      viewed.unshift(item);
      window.localStorage.setItem(storageKey, JSON.stringify(viewed.slice(0, 10)));
    } catch (error) {
      // Storage can be unavailable in private browsing; the product page remains usable.
    }
  }

  function responsiveImageUrl(url, width) {
    try {
      var imageUrl = new URL(url, window.location.origin);
      imageUrl.searchParams.set('width', width);
      return imageUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function renderSection(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var grid = section.querySelector('[data-recently-viewed-grid]');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 5;
    if (window.matchMedia('(max-width: 767px)').matches) {
      limit = parseInt(section.getAttribute('data-mobile-limit'), 10) || 4;
    }
    var currency = section.getAttribute('data-currency') || 'GBP';

    function formatPrice(value) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: currency
        }).format(value / 100);
      } catch (error) {
        return (value / 100).toFixed(2) + ' ' + currency;
      }
    }

    function renderProduct(product, url) {
      if (!product || !product.available || !product.featured_image) return;
      var card = document.createElement('a');
      card.className = 'rit-recently-viewed__card';
      card.href = url;

      var imageWrap = document.createElement('div');
      imageWrap.className = 'rit-recently-viewed__image-wrap';
      var image = document.createElement('img');
      image.className = 'rit-recently-viewed__image';
      image.src = responsiveImageUrl(product.featured_image, 480);
      image.srcset = [240, 360, 480, 600].map(function (width) {
        return responsiveImageUrl(product.featured_image, width) + ' ' + width + 'w';
      }).join(', ');
      image.sizes = '(max-width: 767px) 50vw, 20vw';
      image.alt = product.title || '';
      image.loading = 'lazy';
      imageWrap.appendChild(image);
      card.appendChild(imageWrap);

      var title = document.createElement('p');
      title.className = 'rit-recently-viewed__title';
      title.textContent = product.title || '';
      card.appendChild(title);

      var price = document.createElement('p');
      price.className = 'rit-recently-viewed__price';
      price.textContent = formatPrice(product.price);
      card.appendChild(price);
      grid.appendChild(card);
    }

    function isSameStoreProduct(entry) {
      if (!entry || !entry.handle || !entry.url) return false;
      try {
        var url = new URL(entry.url, window.location.origin);
        return url.origin === window.location.origin && url.pathname.indexOf('/products/') !== -1;
      } catch (error) {
        return false;
      }
    }

    var entries = readViewed().filter(isSameStoreProduct).slice(0, limit);
    if (!entries.length) return;

    Promise.all(entries.map(function (entry) {
      return fetch(entry.url.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) { return { product: product, url: entry.url }; })
        .catch(function () { return null; });
    })).then(function (results) {
      results.forEach(function (result) {
        if (result) renderProduct(result.product, result.url);
      });
      if (grid.children.length) section.hidden = false;
    });
  }

  function initializeSections(root) {
    if (!root) return;
    if (root.matches && root.matches('.rit-recently-viewed')) renderSection(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('.rit-recently-viewed').forEach(renderSection);
    }
  }

  function initializeAll() {
    recordCurrentProduct();
    initializeSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });
})();
